import { Button, Space, Table } from "antd";
import { useMemo } from "react";
import { EditOutlined } from "@ant-design/icons";

const UsersTable = (props) => {
  const { users, showModal, loading } = props;

  const columns = useMemo(
    () => [
      {
        title: "Full Name",
        dataIndex: "first_name",
        key: "first_name",
        render: (_, record) => (
          <span>
            {record.first_name} {record?.middle_name} {record.last_name}
          </span>
        ),
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
      },
      {
        title: "Phone Number",
        dataIndex: "mobile_number",
        key: "mobile_number",
        width: 180,
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 220,
      },
      {
        title: "Actions",
        key: "actions",
        width: 150,
        render: (_, record) => (
          <Space>
            <Button icon={<EditOutlined />} onClick={() => showModal(record)} />
          </Space>
        ),
      },
    ],
    []
  );

  return (
    <Table
      columns={columns}
      dataSource={users}
      rowKey="id"
      pagination={{ pageSize: 10 }}
      scroll={{ x: "max-content" }}
      loading={loading}
    />
  );
};

export default UsersTable;
